import jwtDecode from 'jwt-decode';

/**
 * The stored V3 user a page load may resume, or null. An expired token still
 * counts while a refresh token can renew it. app.reducer's initial user is
 * exactly this, so a stored V3 session is judged the same way everywhere.
 */
export function restorableV3User() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (jwtDecode(user.token).exp < Date.now() / 1000 && !localStorage.getItem('rt')) return null;
    return user;
  } catch (_) {
    return null;
  }
}

// `user`, plus the admin a V3 "login as" returns to.
const V3_SESSION_KEYS = ['user', 'adminUser', 'accountManagerUser'];

/**
 * Drops what a V3 session left behind when it ended without the logout saga: its
 * token expired with no refresh token, or the env-override dialog removed only
 * `user`. A V4 session must not inherit them. The admin keys turn its Logout into
 * "Back to admin", and `user` stops V4client from ending it on a 401.
 * A V3 session that another tab can still resume keeps them.
 */
export function clearOrphanedV3Session() {
  if (restorableV3User()) return;
  V3_SESSION_KEYS.forEach(key => localStorage.removeItem(key));
}
